import React from "react";

const Billing = () => {
  return <>Coming Soon!</>;
};

export default Billing;
